export default __webpack_public_path__ + "static/erichsueh-e82ac29b63f8c4f8d41b845835028588.jpeg";